export const getUserWatchlistQuery = /* GraphQL */ `
  query GetUserWatchlist($userID: ID!, $limit: Int, $nextToken: String) {
    listWatchlistItems(
      filter: { userID: { eq: $userID } }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        movieID
        showID
        contentType
        status
        priority
        notes
        createdAt
      }
      nextToken
    }
  }
`;



export const getUserWatchedQuery = /* GraphQL */ `
  query GetUserWatched($userID: ID!, $limit: Int, $nextToken: String) {
    listWatchedItems(
      filter: { userID: { eq: $userID } }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        movieID
        status
        createdAt
      }
      nextToken
    }
  }
`;

export const createWatchlistItemMutation = /* GraphQL */ `
  mutation CreateWatchlistItem($input: CreateWatchlistItemInput!) {
    createWatchlistItem(input: $input) {
      id
      userID
      movieID
      showID
      contentType
      status
      priority
      notes
      createdAt
    }
  }
`;

export const createWatchedItemMutation = /* GraphQL */ `
  mutation CreateWatchedItem($input: CreateWatchedItemInput!) {
    createWatchedItem(input: $input) {
      id
      userID
      movieID
      status
      createdAt
    }
  }
`;

export const deleteWatchlistItemMutation = /* GraphQL */ `
  mutation DeleteWatchlistItem($input: DeleteWatchlistItemInput!) {
    deleteWatchlistItem(input: $input) {
      id
    }
  }
`;

export const deleteWatchedItemMutation = /* GraphQL */ `
  mutation DeleteWatchedItem($input: DeleteWatchedItemInput!) {
    deleteWatchedItem(input: $input) {
      id
    }
  }
`;